import { deflate } from "pako";
import { record } from "rrweb";
import { sendRecordingPartQuery } from "@query";

export class SessionRecorderWorker {
  ws = null;
  sessionId = null;
  events = [];

  useCompression = false;

  recorderStarted = false;
  idleChecker = null;
  recordConsumer = null;
  recordEmitter = null;

  sendChecker = 0;
  maxSendDelay = 20; // for an interval that triggers every 100ms -> 20 * 100ms -> 2000ms -> 2sec
  maxPartLength = 64 * 1024;

  constructor(useCompression = true) {
    this.useCompression = useCompression;

    this.sendData = this.sendData.bind(this);
    this.prepareDataDispatch = this.prepareDataDispatch.bind(this);
  }

  startRecording = async (newSessionId) => {
    if(!this.sessionId && !newSessionId)
      return;
    
    this.clearOldRecordingData();
    
    if(newSessionId)
      this.sessionId = newSessionId;
    
    const that = this;
    
    this.recordEmitter = record({
      collectFonts: true,
      blockClass: /react-pdf__Page__((textContent)|(Thumb))/,
      blockSelector: "html > *:not(body):not(head), html > body > *:not(#root):not(#commentThread)",
      inlineImages: false,
      inlineStylesheet: false,
      slimDOMOptions: {
        script: false,
        comment: false,
        headFavicon: false,
        headWhitespace: false,
        headMetaDescKeywords: false,
        headMetaSocial: false,
        headMetaRobots: false,
        headMetaHttpEquiv: false,
        headMetaAuthorship: false,
        headMetaVerification: false,
      },
      sampling: {
        mouseInteraction: {
          MouseUp: false,
          MouseDown: false,
          TouchStart: false,
          TouchEnd: false,
          ContextMenu: false,
        },
        scroll: 300,
      },
      emit(event) {
        that.events.push(event);
      },
    });
    this.recordConsumer = setInterval(() => this.prepareDataDispatch(), 100);
    this.recorderStarted = true;
    console.log("new session started!");
  };

  endRecording = async () => {
    if (!this.recorderStarted)
      return;
    
    console.log("stopping current session!");
    await this.prepareDataDispatch();
    this.recorderStarted = false;
    
    this.clearOldRecordingData();
  };

  prepareDataDispatch = async () => {
    if (this.events.length && this.recorderStarted) {
      this.sendChecker++;
      const body = JSON.stringify(this.events);
      if (this.sendChecker >= this.maxSendDelay) {
        const timestamp = this.events[0].timestamp;
        this.sendData(body, timestamp);
        this.events = [];
        this.sendChecker = 0;
      }
    }
  };

  sendData = async (body, timestamp) => {
    if (this.useCompression) body = deflate(body);
    if (body.length > this.maxPartLength) {
      for (let i = 0; i < Math.ceil(body.length / this.maxPartLength); i++) {
        const part = body.slice(
          i * this.maxPartLength,
          i * this.maxPartLength + this.maxPartLength
        );
        sendRecordingPartQuery(
          this.sessionId,
          part,
          timestamp,
          i + 1
        );
      }
      return;
    }

    await sendRecordingPartQuery(this.sessionId, body, timestamp);
  };
  
  clearOldRecordingData = () => {
    this.events = [];
    
    if (this.recordEmitter) {
      this.recordEmitter();
      delete this.recordEmitter;
    }
    
    clearInterval(this.recordConsumer);
    delete this.recordConsumer;
  }

  destroy() {
    this.endRecording();
    clearInterval(this.idleChecker);
    delete this;
  }
}
